// extracted by mini-css-extract-plugin
export default {"header":"Microcomponentik_header__dlNlD","text":"Microcomponentik_text__E-C5f","wrapper":"Microcomponentik_wrapper__n9rma","mark":"Microcomponentik_mark__blUIE"};